import { render } from "./ManageClients.vue?vue&type=template&id=023bb66a"
import script from "./ManageClients.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageClients.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/ManageClients.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "023bb66a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('023bb66a', __exports__)) {
    api.reload('023bb66a', __exports__)
  }
  
  module.hot.accept("./ManageClients.vue?vue&type=template&id=023bb66a", () => {
    api.rerender('023bb66a', render)
  })

}


export default __exports__